import { render, staticRenderFns } from "./Setor.vue?vue&type=template&id=93a5a9ca&scoped=true&"
import script from "./Setor.vue?vue&type=script&lang=js&"
export * from "./Setor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a5a9ca",
  null
  
)

export default component.exports